import React from 'react'

import {interfaceLanguage} from '~/services/intl'

const localizedComponents = {
    ru: React.lazy(() => import('./SynthesisPronunciation.ru')),
    en: React.lazy(() => import('./SynthesisPronunciation.en')),
}

const LocalizedComponent = localizedComponents[interfaceLanguage]

export default function SynthesisPronunciation() {
    // const [documentElement, setDocumentElement] = useState<HTMLDivElement>()

    return <div className='documentation__text'>
        <div className='documentation__text-wrapper DocumentationContainer'>
            <div className='row row_top row_gap-10 row_nowrap'>
                <div
                    className='documentation__text-content'
                    // ref={element => element && setDocumentElement(element)}
                >
                    <LocalizedComponent/>
                </div>
                {/* TODO доработать сабменю */}
                {/* {documentElement && <DocumentationSubmenu content={documentElement}/>} */}
            </div>
        </div>
    </div>
}
